import React from "react";
import styles from "./footer.module.css"
import Icons from "./icons";

const Footer = () => {
  return (
    <div className={styles.footer}>
    <Icons/>
    </div>
  
  );
};

export default Footer;
